import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import { Component, useState } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import { MenuItem, Typography } from '@mui/material'
import placeholder from '../../../assets/icons/picture.svg'
import { digitByLocal } from '../../../helpers/formatters/digit'
import { isRtl } from '../../../settings'
import { thousandsSeparator } from '../../../helpers/generalHelpers'
import { FormattedMessage } from 'react-intl'
import Select from '@mui/material/Select'
import Modal from '../../GeneralComponents/Modal'
import ImageCarousel from './Carousel'
import { observer } from 'mobx-react'
import formState from 'components/Pages/FormMaker/formState'

const useStyles = makeStyles((theme) => ({
  productInput: {
    width: 280,
    minHeight: 350,
    margin: theme.spacing(1, 0),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  noImageProduct: {
    minHeight: 'auto',
  },
  media: {
    width: '100%',
    height: 200,
    objectFit: 'contain',
    background: 'transparent',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  thumbnailPlaceholder: {
    backgroundSize: 'contain',
  },
  title: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  price: {
    margin: theme.spacing(1, 0),
    fontWeight: 'bold',
  },
  quantitySelect: {
    width: 100,
    margin: theme.spacing(0.4, 0),
  },
  quantity: {
    marginTop: theme.spacing(2),
  },
}))

const formatPrice = (price, unit = '') => {
  const formattedPrice = isRtl ? parseInt(price) : price
  return (
    <FormattedMessage
      id="form.field.product.unitPrice"
      values={{
        price: digitByLocal(thousandsSeparator(formattedPrice) || 0),
        unit,
      }}
    />
  )
}

const Product = (props) => {
  const [isModalOpen, openModal] = useState(false)
  const classes = useStyles()
  const {
    label: title = '',
    images = [],
    required,
    touched,
    error,
    description,
    fullWidth,
    unit_price: unitPrice = 0,
    min_value: min = 0,
    max_value: max,
    formCurrency = {},
    is_subscription,
  } = props

  const formCurrencySign = formCurrency && formCurrency.sign

  const classNames = {
    'formz-has-error': error,
    'full-width': fullWidth,
  }

  const quantityOptions = () => {
    const minCount = Number(min)
    const maxCount = Number(max)
    const quantityRange = maxCount - minCount + 1
    const listLength = Boolean(Number(quantityRange) > 0) ? quantityRange : 0
    return Array.from(new Array(listLength)).map((_, index) => {
      return {
        slug: index + minCount,
        title: digitByLocal(index + minCount),
      }
    })
  }
  const quantitySelect = (
    <Typography
      variant="body2"
      color="secondary"
      component="div"
      className={classes.quantity}
    >
      <Typography
        variant="body2"
        component="p"
        className="formz-product-quantity"
      >
        <FormattedMessage id="form.field.product.quantity" />
      </Typography>
      <Select
        labelId="product-quantity-selector-label"
        id="product-quantity-selector"
        variant="outlined"
        className={clsx({
          [classes.quantitySelect]: true,
          'formz-product-quantity-select': true,
        })}
        value={min}
      >
        {quantityOptions().map((quantity) => (
          <MenuItem value={quantity.slug} key={quantity.slug}>
            {quantity.title}
          </MenuItem>
        ))}
      </Select>
    </Typography>
  )
  const thumbnail = (images.length && images[0].image) || placeholder
  return (
    <FieldRowWrapper className={classNames} error={error} touched={touched}>
      <Card
        className={clsx({
          'formz-product-input': true,
          [classes.productInput]: true,
          [classes.noImageProduct]: Boolean(images.length === 0),
        })}
      >
        {images.length > 0 && (
          <CardMedia
            className={clsx({
              [classes.media]: true,
              [classes.thumbnailPlaceholder]: !images.length,
            })}
            image={thumbnail}
            title={title}
            onClick={() => images.length && openModal(true)}
          />
        )}
        <CardContent>
          <Typography
            gutterBottom
            variant="body1"
            component="p"
            className={clsx({
              [classes.title]: true,
              'formz-product-title': true,
            })}
          >
            {title}
            {required && '(*)'}
          </Typography>
          <Typography
            variant="body2"
            component="p"
            className="formz-product-description"
          >
            {description}
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            component="p"
            className={clsx({
              [classes.price]: true,
              'formz-product-price': true,
            })}
          >
            {!is_subscription && formatPrice(unitPrice, formCurrencySign)}
          </Typography>
          {!is_subscription && quantitySelect}
        </CardContent>
      </Card>
      <Modal maxWidth="md" open={isModalOpen} onClose={() => openModal(false)}>
        <ImageCarousel images={images} />
      </Modal>
    </FieldRowWrapper>
  )
}

class ProductInput extends Component {
  render() {
    const formCurrency = formState.$('currency').$value

    return <Product formCurrency={formCurrency} {...this.props} />
  }
}
export default observer(ProductInput)
